import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper-notifications" }
const _hoisted_2 = { class: "wrapper-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_GeneralTextArea = _resolveComponent("GeneralTextArea")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "above-info" }, [
      _createElementVNode("p", null, "Notificaciones")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GeneralInput, {
        text: _ctx.title.val,
        "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title.val) = $event)),
        value: _ctx.title.val,
        label: 'Título',
        "has-error": _ctx.title.enabled,
        error: _ctx.title.errors.length === 0 ? '' : _ctx.title.errors[0]
      }, null, 8, ["text", "value", "has-error", "error"]),
      _createVNode(_component_GeneralTextArea, {
        text: _ctx.description.val,
        "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description.val) = $event)),
        value: _ctx.description.val,
        label: 'Contenido',
        "has-error": _ctx.description.enabled,
        error: _ctx.description.errors.length === 0 ? '' : _ctx.description.errors[0]
      }, null, 8, ["text", "value", "has-error", "error"]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Enviar notificación',
        class: "margin-button",
        "is-disabled": _ctx.successForm,
        onClick: _ctx.createnotificationTransaction
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}